import {
  REFERRALS_SET_FILTERS,
  REFERRALS_CLEAR_FILTERS,
  REFERRALS_SET_PAGE,
  REFERRALS_SET_PAGE_SIZE,
  REFERRALS_SET_SEARCH,
  REFERRALS_SET_SORT,
  REFERRALS_FETCH_REQUEST,
  REFERRALS_FETCH_SUCCESS,
  REFERRALS_FETCH_FAILURE,
} from '../actions/actionTypes';
import { ReferralsAction } from '../actions/referralsActions';
import { FiltersState, EMPTY_FILTERS } from '../../Talent/components/FiltersDrawer';
import { RawTalentRow } from '../../Talent/transformers/talentTransformer';

export interface ReferralsState {
  filters: FiltersState;
  search: string;
  sort: { column: string; direction: string } | null;
  data: RawTalentRow[];
  pagination: { page: number; pageSize: number; total: number; totalPages: number };
  loading: boolean;
  error: string | null;
}

const initialState: ReferralsState = {
  filters: EMPTY_FILTERS,
  search: '',
  sort: null,
  data: [],
  pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
  loading: false,
  error: null,
};

export default function referralsReducer(
  state: ReferralsState = initialState,
  action: ReferralsAction,
): ReferralsState {
  switch (action.type) {
    case REFERRALS_SET_FILTERS:
      return { ...state, filters: action.payload, pagination: { ...state.pagination, page: 1 } };
    case REFERRALS_CLEAR_FILTERS:
      return { ...state, filters: EMPTY_FILTERS, pagination: { ...state.pagination, page: 1 } };
    case REFERRALS_SET_SEARCH:
      return { ...state, search: action.payload, pagination: { ...state.pagination, page: 1 } };
    case REFERRALS_SET_SORT:
      return { ...state, sort: action.payload, pagination: { ...state.pagination, page: 1 } };
    case REFERRALS_SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };
    case REFERRALS_SET_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } };
    case REFERRALS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case REFERRALS_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload.data, pagination: action.payload.pagination };
    case REFERRALS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
